module.exports = __webpack_public_path__ + "img/products7.01baf810.jpg";